<ng-template>
  <ng-content></ng-content>
</ng-template>
<ng-container [ngTemplateOutlet]="_transparentChild?._template || _template"></ng-container>
